import { render, staticRenderFns } from "./ModalGerarFormulaIA.vue?vue&type=template&id=2fda537a&scoped=true"
import script from "./ModalGerarFormulaIA.vue?vue&type=script&lang=js"
export * from "./ModalGerarFormulaIA.vue?vue&type=script&lang=js"
import style0 from "./ModalGerarFormulaIA.vue?vue&type=style&index=0&id=2fda537a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fda537a",
  null
  
)

export default component.exports